import { render, staticRenderFns } from "./MemberPrivacyConsignment.vue?vue&type=template&id=b2c2a910&scoped=true&"
import script from "./MemberPrivacyConsignment.vue?vue&type=script&lang=js&"
export * from "./MemberPrivacyConsignment.vue?vue&type=script&lang=js&"
import style0 from "./MemberPrivacyConsignment.vue?vue&type=style&index=0&id=b2c2a910&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2a910",
  null
  
)

export default component.exports